export const lineShareMetadata = { };
